import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-contrato',
  templateUrl: './btn-nuevo-contrato.component.html',
  styleUrls: ['./btn-nuevo-contrato.component.css']
})
export class BtnNuevoContratoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
